export function limit(string = "", limited = 0) {
  if (string?.length > limited) {
    return `${string.substring(0, limited)} ...`;
  }
  return string;
}
